import { createSelector } from 'reselect';

export const currentItemSelector = createSelector(
  (state) => state.design,
  (design) => design.currentItem,
);
